import styles from "./FileInputSelector.module.css";

export default function ValidationErrorMessage({
  validationMessages,
  touched,
}: {
  validationMessages: string[];
  touched: boolean;
}) {
  return touched && validationMessages.length > 0 ? (
    <tr>
      <th className="label"></th>
      <td className={"value " + styles.warning}>
        <ul>
          {validationMessages.map((m) => (
            <li key={m}>{m}</li>
          ))}
        </ul>
      </td>
    </tr>
  ) : null;
}
